/* eslint-disable guard-for-in */
import _ from 'lodash';
import { openErrorModal } from '../../actions';
import { addCity, createDistrict, updateDeliveryZone } from '../../apis/shop.service';
import {
  SUBLOCALITY_LEVEL_1,
  FIRST_LEVEL,
  SECOND_LEVEL,
  ERROR_UPDATE_DELIVERY_ZONE,
  DEFAULT_RADIUS,
  ERROR_NO_DELIVERY_ZONE,
  INVALID_ADDRESS,
} from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { getDefaultSquareBounding, getRandomColor, keyGenerator } from '../../utils/tools';
import { getPlacesDetails } from 'src/apis/backend';

export const handleSelectSuggest = async (placeId, component) => {
  const geocodedPrediction = await getPlacesDetails(placeId)
  const { deliveryZone } = component.state;
  const { cityName, districtName } = deliveryZone;
  const { zoneLevel = '' } = component.props;
  const {
    addressComponents = [],
    formattedAddress: valueGeolocApi
  } = geocodedPrediction;
  let typeZone = false;
  const { types = [], longText: longName = '' } = addressComponents[0];
  if (
    (types[0] === 'locality' && zoneLevel === FIRST_LEVEL) ||
    ((types[0] === 'neighborhood' || types[0] === SUBLOCALITY_LEVEL_1) &&
      zoneLevel === SECOND_LEVEL &&
      _.find(addressComponents, { longText: cityName }))
  ) {
    typeZone = types[0];
    component.setState({
      search: '',
      valueGeolocApi: typeZone ? valueGeolocApi : '',
      isFilledAddressValid: true,
      deliveryZone: {
        ...deliveryZone,
        districtName: zoneLevel === SECOND_LEVEL ? longName : districtName,
        cityName: zoneLevel === FIRST_LEVEL ? longName : cityName,
        typeZone
      }
    });
  }
};

export const handleInputChange = (typedAddress, component) => {
  component.setState({ search: typedAddress, valueGeolocApi: typedAddress, isFilledAddressValid: false });
};



export const handleDeliveryZone = async component => {
  const { configurations, addCityModal, onClick } = component.props;
  const { address = {}, deliveryZones } = configurations;
  const { location = {} } = address;
  const { deliveryZone } = component.state;
  const {
    servicePrice: deliveryFees,
    minimum,
    shape = 'circle',
    priority,
    color,
    key,
    data
  } = deliveryZone;
  _.map(deliveryFees, (pallier, i) => {
    _.map(pallier, (elt, key) => {
      deliveryFees[i][key] = pallier[key] === '' ? 0 : pallier[key];
    });
  });
  try {
    let newZone = {
      deliveryFees,
      minimum: minimum === '' ? 0 : minimum,
      shape,
      priority,
      color,
      key,
      data
    };
    if (addCityModal) {
      newZone = {
        ...newZone,
        priority: _.size(deliveryZones) + 1,
        color: getRandomColor(),
        key: keyGenerator('ZONE'),
        data:
          shape === 'circle'
            ? { ...location, radius: DEFAULT_RADIUS }
            : getDefaultSquareBounding(parseFloat(location.latitude), parseFloat(location.longitude))
      };
    }
    await updateDeliveryZone(newZone);
    onClick(newZone);
    handleClose(component);
  } catch (e) {
    sendCloudWatchAlert(`Could not add/update delivery zone ${e}`);
    openErrorModal(ERROR_UPDATE_DELIVERY_ZONE);
  }
};

export const toFormatCityData = (servicePrice, mini, name, component) => {
  const userServicePrice = { ...servicePrice };
  let minimum = 0;
  minimum = mini === '' ? 0 : mini;
  _.map(servicePrice, (pallier, i) => {
    _.map(pallier, (elt, key) => {
      userServicePrice[i][key] = pallier[key] === '' ? 0 : pallier[key];
    });
  });
  for (const a in userServicePrice) {
    for (const b in userServicePrice) {
      if (userServicePrice[a].priceOrder === userServicePrice[b].priceOrder && a !== b) {
        delete userServicePrice[b];
      }
    }
  }
  let returnCity = {
    userServicePrice,
    minimum,
    name
  };
  if (!component.props.addCityModal) {
    returnCity = {
      ...component.props.configurations.openCities[name],
      ...returnCity
    };
  }
  return returnCity;
};

export const handleNewCity = async component => {
  const { openErrorModal, zoneLevel, onClick } = component.props;
  const { deliveryZone, addCityModal } = component.state;
  const {
    servicePrice: userServicePrice = {},
    minimum = 0,
    cityName = '',
    districtName = '',
    typeZone
  } = deliveryZone;
  if (typeZone || !addCityModal) {
    try {
      const name = zoneLevel === FIRST_LEVEL ? cityName : districtName;
      const newCity = toFormatCityData(userServicePrice, minimum, name, component);
      if (name.replace(/\s+/g, '').length > 0) {
        if (zoneLevel === FIRST_LEVEL) {
          await addCity(newCity)
        } else {
          await createDistrict(newCity, cityName, typeZone === SUBLOCALITY_LEVEL_1);
          onClick(cityName);
        }
        handleClose(component);
      } else {
        openErrorModal(INVALID_ADDRESS);
      }
    } catch (e) {
      sendCloudWatchAlert(`Could not add/update delivery city ${e}`);
      openErrorModal(ERROR_UPDATE_DELIVERY_ZONE);
    }
  } else {
    openErrorModal(ERROR_NO_DELIVERY_ZONE);
  }
};

export const handleChangeFees = (event, component) => {
  const { deliveryZone } = component.state;
  const localServicePrice = { ...deliveryZone.servicePrice };
  const { id, value } = event.target;
  if (value) {
    localServicePrice[id].priceOrder = parseFloat(value.slice(0, 6));
  } else {
    localServicePrice[id].priceOrder = '';
  }
  component.setState({ deliveryZone: { ...deliveryZone, servicePrice: localServicePrice } });
};

export const handleChangeFeesValue = (event, component) => {
  const { deliveryZone } = component.state;
  const localServicePrice = { ...deliveryZone.servicePrice };
  const { id, value } = event.target;
  if (value) {
    localServicePrice[id].fees = parseFloat(value.slice(0, 5));
  } else {
    localServicePrice[id].fees = '';
  }
  component.setState({ deliveryZone: { ...deliveryZone, servicePrice: localServicePrice } });
};

export const handleChangeMinimum = (event, component) => {
  const { value, id } = event.target;
  const { deliveryZone } = component.state;
  component.setState({
    deliveryZone: { ...deliveryZone, [id]: value ? parseFloat(value.slice(0, 6)) : '' }
  });
};
export const handleClose = component => {
  component.props.closeModal();
  component.setState({
    search: '',
    valueGeolocApi: '',
    removeModalOpen: false
  });
};

export const handleRemoveFees = (pallier, component) => {
  const { deliveryZone } = component.state;
  const localServicePrice = { ...deliveryZone.servicePrice };
  if (_.keys(localServicePrice).length > 1) {
    delete localServicePrice[pallier];
  }
  component.setState({ deliveryZone: { ...deliveryZone, servicePrice: localServicePrice } });
};

export const handleAddFees = component => {
  component.setState(prevState => {
    const localServicePrice = { ...prevState.deliveryZone.servicePrice };
    localServicePrice[keyGenerator('FEE')] = {
      priceOrder: 0,
      fees: 0
    };
    return { deliveryZone: { ...prevState.deliveryZone, servicePrice: localServicePrice } };
  });
};
export const updateDeliveryZoneShape = ({ target }, component) => {
  const { deliveryZone } = component.state;
  component.setState({
    deliveryZone: { ...deliveryZone, shape: target.value }
  });
};
